<ng-container *transloco="let t">
  <div class="user-customer" *ngIf="authService.authenticated$ | async">
    <span class="label">
      {{ t('core.layout.header.customer') }}
    </span>
    <span class="value" [class.no-change]="(this.authService.allcusts$ | async) === 'N'" (click)="customerService.changeCustomer()">
      {{ authService.custid$ | async }}
    </span>
  </div>
</ng-container>
